/**
 * Wrapper around the central analytics schema for form events.
 * Kept for backwards compatibility — new code should use `analytics.formSubmitSuccess` directly.
 */
import { analytics } from "./events";

type FormSubmittedPayload = {
  form_id: string;
  service_area?: string;
  has_phone?: boolean;
  page_path?: string;
  source?: string;
};

export function trackFormSubmitted(payload: FormSubmittedPayload) {
  const { form_id, ...rest } = payload;
  analytics.formSubmitSuccess(form_id, rest);
}

export function trackFormError(form_id: string, errorMessage?: string) {
  analytics.formSubmitError(form_id, errorMessage);
}
